// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@awc/XDL/Utilities";
import { rfqRequestQuoteSpecificationsStyles } from "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuoteSpecifications";
import { css } from "styled-components";

rfqRequestQuoteSpecificationsStyles.submitButton = {
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};
rfqRequestQuoteSpecificationsStyles.quoteTypeRadioGroup = {
    css: css`
        display: inline-block;
        padding-bottom: 12px;
        width: 100%;
        flex-direction: row;
        & > div {
            margin-right: 20px;
            display: inline-flex;
        }
    `,
};

rfqRequestQuoteSpecificationsStyles.jobNameTextField = {
    cssOverrides: {
        formField: css`
            padding-bottom: 12px;
        `,
    },
};

rfqRequestQuoteSpecificationsStyles.assignUserSelect = {
    cssOverrides: {
        formField: css`
            padding-bottom: 12px;
        `,
    },
};
